import React from "react";

import { SpotlightActionData, SpotlightActionGroupData } from "@mantine/spotlight";
import { privacyPolicy } from "#root/database/privacyPolicy";
import { searchPages } from "#root/database/searchPages";
import { glossary } from "#root/database/glossary";
import { faq } from "#root/database/faq";
import { legalNotice } from "#root/database/legalNotice";
import { accessibility } from "#root/database/accessibility";
import { termsOfService } from "#root/database/termsOfService";

export const actions: (SpotlightActionGroupData | SpotlightActionData)[] = [
  {
    group: "Pages",
    actions: [...searchPages],
  },
  {
    group: "Privacy Policy",
    actions: [...privacyPolicy],
  },
  {
    group: "Terms Of Service",
    actions: [...termsOfService],
  },
  {
    group: "Legal Notice",
    actions: [...legalNotice],
  },
  {
    group: "Glossary",
    actions: [...glossary],
  },
  {
    group: "FAQ",
    actions: [...faq],
  },
  {
    group: "Accessibility",
    actions: [...accessibility],
  },
];
